//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Return Form UI config by given ID.
 * @param id Form Id.
 * @return Returns given form
 */
export function getFormById(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.FormDto> {
    let url_ = getBaseUrl() + "/api/forms/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetFormById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetFormById(_response);
    });
}

function processGetFormById(response: AxiosResponse): Promise<Types.FormDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("Invalid request. Maybe doctor has no access to study where form is created.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormDto.fromJS(resultData200);
        return Promise.resolve<Types.FormDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormDto>(null as any);
}

/**
 * Update form UI config
 * @param id Id of the form config to update.
 * @param dto New version of the form config.
 */
export function patchForm(id: number, dto: Types.PatchFormConfigDto, config?: AxiosRequestConfig | undefined): Promise<Types.FormDto> {
    let url_ = getBaseUrl() + "/api/forms/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchForm,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchForm(_response);
    });
}

function processPatchForm(response: AxiosResponse): Promise<Types.FormDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormDto.fromJS(resultData200);
        return Promise.resolve<Types.FormDto>(result200);

    } else if (status === 409) {
        const _responseText = response.data;
        let result409: any = null;
        let resultData409  = _responseText;
        result409 = Types.ProblemDetails.fromJS(resultData409);
        return throwException("A server side error occurred.", status, _responseText, _headers, result409);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormDto>(null as any);
}

/**
 * Deletes form UI config by given ID.
 * @param id Id of the form
 */
export function removeForm(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/forms/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveForm,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveForm(_response);
    });
}

function processRemoveForm(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Return Form history of changes by given ID.
 * @return Returns given form history
 */
export function getFormHistoryById(formResultId: number, config?: AxiosRequestConfig | undefined): Promise<Types.FormHistoryDto> {
    let url_ = getBaseUrl() + "/api/forms/{formResultId}/history";
    if (formResultId === undefined || formResultId === null)
      throw new Error("The parameter 'formResultId' must be defined.");
    url_ = url_.replace("{formResultId}", encodeURIComponent("" + formResultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetFormHistoryById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetFormHistoryById(_response);
    });
}

function processGetFormHistoryById(response: AxiosResponse): Promise<Types.FormHistoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("Invalid request. Maybe doctor has no access to study where form is created.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormHistoryDto.fromJS(resultData200);
        return Promise.resolve<Types.FormHistoryDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormHistoryDto>(null as any);
}

/**
 * Gets forms available for logged in user.
 * @param ids (optional) 
 * @param type (optional) 
 */
export function getForms(studyId: number, ids?: number[] | null | undefined, type?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FormDto[]> {
    let url_ = getBaseUrl() + "/api/forms?";
      if (studyId === undefined || studyId === null)
        throw new Error("The parameter 'studyId' must be defined and cannot be null.");
      else
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (ids !== undefined && ids !== null)
        ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
    if (type !== undefined && type !== null)
        url_ += "Type=" + encodeURIComponent("" + type) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetForms,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetForms(_response);
    });
}

function processGetForms(response: AxiosResponse): Promise<Types.FormDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.FormDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.FormDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormDto[]>(null as any);
}

/**
 * Creates new UI form config.
 */
export function createForm(dto: Types.CreateFormConfigDto, config?: AxiosRequestConfig | undefined): Promise<Types.FormDto> {
    let url_ = getBaseUrl() + "/api/forms";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateForm,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateForm(_response);
    });
}

function processCreateForm(response: AxiosResponse): Promise<Types.FormDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("Invalid request. Maybe doctor has no access to study where form is created.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormDto.fromJS(resultData200);
        return Promise.resolve<Types.FormDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.FormDto.fromJS(resultData201);
        return Promise.resolve<Types.FormDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormDto>(null as any);
}

/**
 * Process (saves) results of forms
 * @param awaitScoreCalculation (optional) The flag indicates scoring should be awaited or not
 * @param files (optional) 
 * @param dto (optional) 
 */
export function processResults(awaitScoreCalculation?: boolean | undefined, files?: Types.FileParameter[] | null | undefined, dto?: Types.ProcessFormResultDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results?";
    if (awaitScoreCalculation === null)
        throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
    else if (awaitScoreCalculation !== undefined)
        url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (files !== null && files !== undefined)
        files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
    if (dto === null || dto === undefined)
        throw new Error("The parameter 'dto' cannot be null.");
    else
        content_.append("dto", JSON.stringify(dto));

    let options_: AxiosRequestConfig = {
        ..._requestConfigProcessResults,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProcessResults(_response);
    });
}

function processProcessResults(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

/**
 * Updates results of forms
 * @param awaitScoreCalculation (optional) The flag indicates scoring should be awaited or not
 * @param newFiles (optional) 
 * @param dto (optional) 
 */
export function patchResults(awaitScoreCalculation?: boolean | undefined, newFiles?: Types.FileParameter[] | null | undefined, dto?: Types.UpdateFormResultDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results?";
    if (awaitScoreCalculation === null)
        throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
    else if (awaitScoreCalculation !== undefined)
        url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (newFiles !== null && newFiles !== undefined)
        newFiles.forEach(item_ => content_.append("newFiles", item_.data, item_.fileName ? item_.fileName : "newFiles") );
    if (dto === null || dto === undefined)
        throw new Error("The parameter 'dto' cannot be null.");
    else
        content_.append("dto", JSON.stringify(dto));

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchResults,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchResults(_response);
    });
}

function processPatchResults(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

/**
 * Returns form results.
 * @param formConfigId (optional) Related form config id.
 * @param formTypes (optional) Related form config type.
 * @param patientId (optional) Related patient id.
 * @param patientUniqueId (optional) The unique id of the related patient
 * @param lastFormResultVersionOnly (optional) Get only the last form result version
 * @param lifecycleStates (optional) If not null, only those form result versions will be returned whose lifecycle state is contained here.
 * @param limit (optional) Get requested amount of results.
 * @param orderByDataKey (optional) Order results by value with specified data key
 * @param dataKeyDateFilter_DataKey (optional) Data key name (form field name) by which date-range filter will be applied
 * @param dataKeyDateFilter_Since (optional) Date from which the filter will be applied.
 * @param dataKeyDateFilter_Until (optional) Date until form results will be filtered bu given DataKey.
 * @param formResultId (optional) Related form result id.
 */
export function getFormResults(studyId: number, formConfigId?: number | null | undefined, formTypes?: string[] | null | undefined, patientId?: string | null | undefined, patientUniqueId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, limit?: number | null | undefined, orderByDataKey?: string | null | undefined, dataKeyDateFilter_DataKey?: string | undefined, dataKeyDateFilter_Since?: Date | null | undefined, dataKeyDateFilter_Until?: Date | null | undefined, formResultId?: number | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfFormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results?";
      if (studyId === undefined || studyId === null)
        throw new Error("The parameter 'studyId' must be defined and cannot be null.");
      else
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (formConfigId !== undefined && formConfigId !== null)
        url_ += "FormConfigId=" + encodeURIComponent("" + formConfigId) + "&";
    if (formTypes !== undefined && formTypes !== null)
        formTypes && formTypes.forEach(item => { url_ += "FormTypes=" + encodeURIComponent("" + item) + "&"; });
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (patientUniqueId !== undefined && patientUniqueId !== null)
        url_ += "PatientUniqueId=" + encodeURIComponent("" + patientUniqueId) + "&";
    if (lastFormResultVersionOnly !== undefined && lastFormResultVersionOnly !== null)
        url_ += "LastFormResultVersionOnly=" + encodeURIComponent("" + lastFormResultVersionOnly) + "&";
    if (lifecycleStates !== undefined && lifecycleStates !== null)
        lifecycleStates && lifecycleStates.forEach(item => { url_ += "LifecycleStates=" + encodeURIComponent("" + item) + "&"; });
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (orderByDataKey !== undefined && orderByDataKey !== null)
        url_ += "OrderByDataKey=" + encodeURIComponent("" + orderByDataKey) + "&";
    if (dataKeyDateFilter_DataKey === null)
        throw new Error("The parameter 'dataKeyDateFilter_DataKey' cannot be null.");
    else if (dataKeyDateFilter_DataKey !== undefined)
        url_ += "DataKeyDateFilter.DataKey=" + encodeURIComponent("" + dataKeyDateFilter_DataKey) + "&";
    if (dataKeyDateFilter_Since !== undefined && dataKeyDateFilter_Since !== null)
        url_ += "DataKeyDateFilter.Since=" + encodeURIComponent(dataKeyDateFilter_Since ? "" + Types.formatDate(dataKeyDateFilter_Since) : "") + "&";
    if (dataKeyDateFilter_Until !== undefined && dataKeyDateFilter_Until !== null)
        url_ += "DataKeyDateFilter.Until=" + encodeURIComponent(dataKeyDateFilter_Until ? "" + Types.formatDate(dataKeyDateFilter_Until) : "") + "&";
    if (formResultId !== undefined && formResultId !== null)
        url_ += "FormResultId=" + encodeURIComponent("" + formResultId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetFormResults,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetFormResults(_response);
    });
}

function processGetFormResults(response: AxiosResponse): Promise<Types.PagedResultOfFormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfFormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfFormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfFormResultDto>(null as any);
}

export function skipFormResult(dto: Types.SkipFormResultDto, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results/skip";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSkipFormResult,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSkipFormResult(_response);
    });
}

function processSkipFormResult(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

export function skipAllFormsOnRouteProgressStep(dto: Types.SkipAllFormsOnStepDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/forms/results/skipStep";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSkipAllFormsOnRouteProgressStep,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSkipAllFormsOnRouteProgressStep(_response);
    });
}

function processSkipAllFormsOnRouteProgressStep(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function markFormResultAsSkipped(formResultId: number, dto: Types.MarkFormResultAsSkippedDto, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results/{formResultId}/markAsSkipped";
    if (formResultId === undefined || formResultId === null)
      throw new Error("The parameter 'formResultId' must be defined.");
    url_ = url_.replace("{formResultId}", encodeURIComponent("" + formResultId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigMarkFormResultAsSkipped,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMarkFormResultAsSkipped(_response);
    });
}

function processMarkFormResultAsSkipped(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

export function revokeFormResultSkip(formResultId: number, initialValue: { [key: string]: any; }, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results/{formResultId}/revokeSkip";
    if (formResultId === undefined || formResultId === null)
      throw new Error("The parameter 'formResultId' must be defined.");
    url_ = url_.replace("{formResultId}", encodeURIComponent("" + formResultId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(initialValue);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRevokeFormResultSkip,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRevokeFormResultSkip(_response);
    });
}

function processRevokeFormResultSkip(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

export function markFormResultAsDraft(resultId: number, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultVersionDto> {
    let url_ = getBaseUrl() + "/api/forms/results/{resultId}/markAsDraft";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMarkFormResultAsDraft,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMarkFormResultAsDraft(_response);
    });
}

function processMarkFormResultAsDraft(response: AxiosResponse): Promise<Types.FormResultVersionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultVersionDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultVersionDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultVersionDto>(null as any);
}

export function approveFormResult(resultId: number, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultVersionDto> {
    let url_ = getBaseUrl() + "/api/forms/results/{resultId}/approve";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigApproveFormResult,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processApproveFormResult(_response);
    });
}

function processApproveFormResult(response: AxiosResponse): Promise<Types.FormResultVersionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultVersionDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultVersionDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultVersionDto>(null as any);
}

export function approveAllSkippedFormsOnRouteProgressStep(patientId?: string | undefined, stepName?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/forms/results/approveStep?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
    if (stepName === null)
        throw new Error("The parameter 'stepName' cannot be null.");
    else if (stepName !== undefined)
        url_ += "stepName=" + encodeURIComponent("" + stepName) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigApproveAllSkippedFormsOnRouteProgressStep,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processApproveAllSkippedFormsOnRouteProgressStep(_response);
    });
}

function processApproveAllSkippedFormsOnRouteProgressStep(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function recallFormResultApproval(resultId: number, dto: Types.RecallFormResultApprovalDto, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultVersionDto> {
    let url_ = getBaseUrl() + "/api/forms/results/{resultId}/recallApproval";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigRecallFormResultApproval,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRecallFormResultApproval(_response);
    });
}

function processRecallFormResultApproval(response: AxiosResponse): Promise<Types.FormResultVersionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultVersionDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultVersionDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultVersionDto>(null as any);
}

export function submitForm(resultId: number, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results/{resultId}/submit";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSubmitForm,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSubmitForm(_response);
    });
}

function processSubmitForm(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

export function patchAndSubmitForm(awaitScoreCalculation?: boolean | undefined, newFiles?: Types.FileParameter[] | null | undefined, dto?: Types.UpdateFormResultDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/results/patchAndSubmit?";
    if (awaitScoreCalculation === null)
        throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
    else if (awaitScoreCalculation !== undefined)
        url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (newFiles !== null && newFiles !== undefined)
        newFiles.forEach(item_ => content_.append("newFiles", item_.data, item_.fileName ? item_.fileName : "newFiles") );
    if (dto === null || dto === undefined)
        throw new Error("The parameter 'dto' cannot be null.");
    else
        content_.append("dto", JSON.stringify(dto));

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchAndSubmitForm,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchAndSubmitForm(_response);
    });
}

function processPatchAndSubmitForm(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

/**
 * Returns array of dates by requested form type.
If special data key is not provided - will take results by "filled at" date field.
 * @param patientId (optional) Related patient id.
 * @param formConfigId (optional) Related form config id.
 * @param formType (optional) Related form config type.
 * @param byDataKey (optional) Process results dates by value with specified data key
 */
export function getFormResultDates(patientId?: string | undefined, formConfigId?: number | null | undefined, formType?: string | null | undefined, byDataKey?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDatesDto> {
    let url_ = getBaseUrl() + "/api/forms/results/dates?";
    if (patientId === null)
        throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (formConfigId !== undefined && formConfigId !== null)
        url_ += "FormConfigId=" + encodeURIComponent("" + formConfigId) + "&";
    if (formType !== undefined && formType !== null)
        url_ += "FormType=" + encodeURIComponent("" + formType) + "&";
    if (byDataKey !== undefined && byDataKey !== null)
        url_ += "ByDataKey=" + encodeURIComponent("" + byDataKey) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetFormResultDates,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetFormResultDates(_response);
    });
}

function processGetFormResultDates(response: AxiosResponse): Promise<Types.FormResultDatesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDatesDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDatesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDatesDto>(null as any);
}

/**
 * Returns form result and form UI config by id.
 * @param resultId Form result id.
 */
export function getFormResultById(resultId: number, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultDto> {
    let url_ = getBaseUrl() + "/api/forms/result/{resultId}";
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetFormResultById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetFormResultById(_response);
    });
}

function processGetFormResultById(response: AxiosResponse): Promise<Types.FormResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultDto>(null as any);
}

/**
 * Trigger recalculation form score
 */
export function recalculateScore(formResultId: number, versionNumber: number, minorVersionNumber: number, config?: AxiosRequestConfig | undefined): Promise<Types.FormResultVersionDto> {
    let url_ = getBaseUrl() + "/api/forms/recalculateScore?";
      if (formResultId === undefined || formResultId === null)
        throw new Error("The parameter 'formResultId' must be defined and cannot be null.");
      else
        url_ += "formResultId=" + encodeURIComponent("" + formResultId) + "&";
      if (versionNumber === undefined || versionNumber === null)
        throw new Error("The parameter 'versionNumber' must be defined and cannot be null.");
      else
        url_ += "versionNumber=" + encodeURIComponent("" + versionNumber) + "&";
      if (minorVersionNumber === undefined || minorVersionNumber === null)
        throw new Error("The parameter 'minorVersionNumber' must be defined and cannot be null.");
      else
        url_ += "minorVersionNumber=" + encodeURIComponent("" + minorVersionNumber) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRecalculateScore,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRecalculateScore(_response);
    });
}

function processRecalculateScore(response: AxiosResponse): Promise<Types.FormResultVersionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FormResultVersionDto.fromJS(resultData200);
        return Promise.resolve<Types.FormResultVersionDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FormResultVersionDto>(null as any);
}

/**
 * Upload file
 * @param file (optional) 
 */
export function uploadFile(file?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileDto> {
    let url_ = getBaseUrl() + "/api/forms/UploadFile";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUploadFile,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUploadFile(_response);
    });
}

function processUploadFile(response: AxiosResponse): Promise<Types.FileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FileDto.fromJS(resultData200);
        return Promise.resolve<Types.FileDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileDto>(null as any);
}
let _requestConfigGetFormById: Partial<AxiosRequestConfig> | null;
export function getGetFormByIdRequestConfig() {
  return _requestConfigGetFormById;
}
export function setGetFormByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetFormById = value;
}
export function patchGetFormByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetFormById = patch(_requestConfigGetFormById ?? {});
}

let _requestConfigPatchForm: Partial<AxiosRequestConfig> | null;
export function getPatchFormRequestConfig() {
  return _requestConfigPatchForm;
}
export function setPatchFormRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchForm = value;
}
export function patchPatchFormRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchForm = patch(_requestConfigPatchForm ?? {});
}

let _requestConfigRemoveForm: Partial<AxiosRequestConfig> | null;
export function getRemoveFormRequestConfig() {
  return _requestConfigRemoveForm;
}
export function setRemoveFormRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveForm = value;
}
export function patchRemoveFormRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveForm = patch(_requestConfigRemoveForm ?? {});
}

let _requestConfigGetFormHistoryById: Partial<AxiosRequestConfig> | null;
export function getGetFormHistoryByIdRequestConfig() {
  return _requestConfigGetFormHistoryById;
}
export function setGetFormHistoryByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetFormHistoryById = value;
}
export function patchGetFormHistoryByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetFormHistoryById = patch(_requestConfigGetFormHistoryById ?? {});
}

let _requestConfigGetForms: Partial<AxiosRequestConfig> | null;
export function getGetFormsRequestConfig() {
  return _requestConfigGetForms;
}
export function setGetFormsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetForms = value;
}
export function patchGetFormsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetForms = patch(_requestConfigGetForms ?? {});
}

let _requestConfigCreateForm: Partial<AxiosRequestConfig> | null;
export function getCreateFormRequestConfig() {
  return _requestConfigCreateForm;
}
export function setCreateFormRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateForm = value;
}
export function patchCreateFormRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateForm = patch(_requestConfigCreateForm ?? {});
}

let _requestConfigProcessResults: Partial<AxiosRequestConfig> | null;
export function getProcessResultsRequestConfig() {
  return _requestConfigProcessResults;
}
export function setProcessResultsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProcessResults = value;
}
export function patchProcessResultsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProcessResults = patch(_requestConfigProcessResults ?? {});
}

let _requestConfigPatchResults: Partial<AxiosRequestConfig> | null;
export function getPatchResultsRequestConfig() {
  return _requestConfigPatchResults;
}
export function setPatchResultsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchResults = value;
}
export function patchPatchResultsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchResults = patch(_requestConfigPatchResults ?? {});
}

let _requestConfigGetFormResults: Partial<AxiosRequestConfig> | null;
export function getGetFormResultsRequestConfig() {
  return _requestConfigGetFormResults;
}
export function setGetFormResultsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetFormResults = value;
}
export function patchGetFormResultsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetFormResults = patch(_requestConfigGetFormResults ?? {});
}

let _requestConfigSkipFormResult: Partial<AxiosRequestConfig> | null;
export function getSkipFormResultRequestConfig() {
  return _requestConfigSkipFormResult;
}
export function setSkipFormResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSkipFormResult = value;
}
export function patchSkipFormResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSkipFormResult = patch(_requestConfigSkipFormResult ?? {});
}

let _requestConfigSkipAllFormsOnRouteProgressStep: Partial<AxiosRequestConfig> | null;
export function getSkipAllFormsOnRouteProgressStepRequestConfig() {
  return _requestConfigSkipAllFormsOnRouteProgressStep;
}
export function setSkipAllFormsOnRouteProgressStepRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSkipAllFormsOnRouteProgressStep = value;
}
export function patchSkipAllFormsOnRouteProgressStepRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSkipAllFormsOnRouteProgressStep = patch(_requestConfigSkipAllFormsOnRouteProgressStep ?? {});
}

let _requestConfigMarkFormResultAsSkipped: Partial<AxiosRequestConfig> | null;
export function getMarkFormResultAsSkippedRequestConfig() {
  return _requestConfigMarkFormResultAsSkipped;
}
export function setMarkFormResultAsSkippedRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMarkFormResultAsSkipped = value;
}
export function patchMarkFormResultAsSkippedRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMarkFormResultAsSkipped = patch(_requestConfigMarkFormResultAsSkipped ?? {});
}

let _requestConfigRevokeFormResultSkip: Partial<AxiosRequestConfig> | null;
export function getRevokeFormResultSkipRequestConfig() {
  return _requestConfigRevokeFormResultSkip;
}
export function setRevokeFormResultSkipRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRevokeFormResultSkip = value;
}
export function patchRevokeFormResultSkipRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRevokeFormResultSkip = patch(_requestConfigRevokeFormResultSkip ?? {});
}

let _requestConfigMarkFormResultAsDraft: Partial<AxiosRequestConfig> | null;
export function getMarkFormResultAsDraftRequestConfig() {
  return _requestConfigMarkFormResultAsDraft;
}
export function setMarkFormResultAsDraftRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMarkFormResultAsDraft = value;
}
export function patchMarkFormResultAsDraftRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMarkFormResultAsDraft = patch(_requestConfigMarkFormResultAsDraft ?? {});
}

let _requestConfigApproveFormResult: Partial<AxiosRequestConfig> | null;
export function getApproveFormResultRequestConfig() {
  return _requestConfigApproveFormResult;
}
export function setApproveFormResultRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigApproveFormResult = value;
}
export function patchApproveFormResultRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigApproveFormResult = patch(_requestConfigApproveFormResult ?? {});
}

let _requestConfigApproveAllSkippedFormsOnRouteProgressStep: Partial<AxiosRequestConfig> | null;
export function getApproveAllSkippedFormsOnRouteProgressStepRequestConfig() {
  return _requestConfigApproveAllSkippedFormsOnRouteProgressStep;
}
export function setApproveAllSkippedFormsOnRouteProgressStepRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigApproveAllSkippedFormsOnRouteProgressStep = value;
}
export function patchApproveAllSkippedFormsOnRouteProgressStepRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigApproveAllSkippedFormsOnRouteProgressStep = patch(_requestConfigApproveAllSkippedFormsOnRouteProgressStep ?? {});
}

let _requestConfigRecallFormResultApproval: Partial<AxiosRequestConfig> | null;
export function getRecallFormResultApprovalRequestConfig() {
  return _requestConfigRecallFormResultApproval;
}
export function setRecallFormResultApprovalRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRecallFormResultApproval = value;
}
export function patchRecallFormResultApprovalRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRecallFormResultApproval = patch(_requestConfigRecallFormResultApproval ?? {});
}

let _requestConfigSubmitForm: Partial<AxiosRequestConfig> | null;
export function getSubmitFormRequestConfig() {
  return _requestConfigSubmitForm;
}
export function setSubmitFormRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSubmitForm = value;
}
export function patchSubmitFormRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSubmitForm = patch(_requestConfigSubmitForm ?? {});
}

let _requestConfigPatchAndSubmitForm: Partial<AxiosRequestConfig> | null;
export function getPatchAndSubmitFormRequestConfig() {
  return _requestConfigPatchAndSubmitForm;
}
export function setPatchAndSubmitFormRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchAndSubmitForm = value;
}
export function patchPatchAndSubmitFormRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchAndSubmitForm = patch(_requestConfigPatchAndSubmitForm ?? {});
}

let _requestConfigGetFormResultDates: Partial<AxiosRequestConfig> | null;
export function getGetFormResultDatesRequestConfig() {
  return _requestConfigGetFormResultDates;
}
export function setGetFormResultDatesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetFormResultDates = value;
}
export function patchGetFormResultDatesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetFormResultDates = patch(_requestConfigGetFormResultDates ?? {});
}

let _requestConfigGetFormResultById: Partial<AxiosRequestConfig> | null;
export function getGetFormResultByIdRequestConfig() {
  return _requestConfigGetFormResultById;
}
export function setGetFormResultByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetFormResultById = value;
}
export function patchGetFormResultByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetFormResultById = patch(_requestConfigGetFormResultById ?? {});
}

let _requestConfigRecalculateScore: Partial<AxiosRequestConfig> | null;
export function getRecalculateScoreRequestConfig() {
  return _requestConfigRecalculateScore;
}
export function setRecalculateScoreRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRecalculateScore = value;
}
export function patchRecalculateScoreRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRecalculateScore = patch(_requestConfigRecalculateScore ?? {});
}

let _requestConfigUploadFile: Partial<AxiosRequestConfig> | null;
export function getUploadFileRequestConfig() {
  return _requestConfigUploadFile;
}
export function setUploadFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUploadFile = value;
}
export function patchUploadFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUploadFile = patch(_requestConfigUploadFile ?? {});
}